import { render, staticRenderFns } from "./HeaderChatbot.vue?vue&type=template&id=189e215e&scoped=true&"
import script from "./HeaderChatbot.vue?vue&type=script&lang=js&"
export * from "./HeaderChatbot.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChatbot.vue?vue&type=style&index=0&id=189e215e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e215e",
  null
  
)

export default component.exports